export const maxMin = [
  [400, 1600],
  [1600, 7120],
  [24250, 52600],
  [52600, 100000],
];
